import { Chip } from "@mui/material";
import { IMerchantOrdersInvoice, InvoicePaymentMethod, MerchantOrdersInvoiceState } from "../interfaces/common/merchant-invoices";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import EventIcon from "@mui/icons-material/Event";
import SyncIcon from "@mui/icons-material/Sync";
import VerifiedIcon from "@mui/icons-material/Verified";
import ErrorIcon from "@mui/icons-material/Error";
import CancelIcon from "@mui/icons-material/Cancel";
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import SwipeUpIcon from '@mui/icons-material/SwipeUp';
import ReplayIcon from '@mui/icons-material/Replay';
import { AttachMoney, QuestionMark } from "@mui/icons-material";

export const showMerchantInvoiceState = (state: MerchantOrdersInvoiceState): JSX.Element => {
    switch (state) {
        case MerchantOrdersInvoiceState.PENDING_PAYMENT:
            return <Chip size="small" icon={<HourglassBottomIcon />} label={"Awaiting Payment"} />;
        case MerchantOrdersInvoiceState.PAYMENT_SCHEDULED:
            return <Chip size="small" icon={<EventIcon />} label={"Payment Scheduled"} />;
        case MerchantOrdersInvoiceState.COLLECTED_BY_DRIVER:
            return <Chip size="small" icon={<SwipeUpIcon />} label={"Collected By Driver"} />;
        case MerchantOrdersInvoiceState.IN_PROGRESS:
            return <Chip size="small" icon={<SyncIcon />} label={"In Progress"} />;
        case MerchantOrdersInvoiceState.PAID:
            return <Chip size="small" icon={<VerifiedIcon />} label={"Paid"} />;
        case MerchantOrdersInvoiceState.AWAITING_RETURN:
            return <Chip size="small" icon={<ReplayIcon />} label={"Awaiting Return"} />;
        case MerchantOrdersInvoiceState.FAILED:
            return <Chip size="small" icon={<ErrorIcon />} label={"Payment Failed"} />;
        case MerchantOrdersInvoiceState.CANCELLED:
            return <Chip size="small" icon={<CancelIcon />} label={"Cancelled"} />;
        default:
            return <Chip size="small" label={"Unknown State"} />;
    }
};

// Small component to show whishmoneyicon.svg as a chip similar to MUI chips
const WhishMoneyChip = () => (
    <img 
        src="/whishmoneyicon.svg" 
        alt="Whish Money" 
        style={{ 
            height: '24px',
            padding: '4px 8px',
            backgroundColor: '#f5f5f5',
            borderRadius: '16px',
            display: 'inline-flex',
            alignItems: 'center',
            objectFit: 'contain',
            verticalAlign: 'middle'
        }} 
    />
);

export const showPaymentMethod = (method: InvoicePaymentMethod): JSX.Element => {
    switch(method) {
        case InvoicePaymentMethod.CASH:
            return <Chip size="small" icon={<AttachMoney />} variant={"outlined"} label={"Cash"} color="info"/>
        case InvoicePaymentMethod.WHISH:
            return <WhishMoneyChip />
        default:
            return <Chip size="small" icon={<QuestionMark />} label={"Unkown"} />
    }
}

export const canCancelMerchantInvoice = (invoice: IMerchantOrdersInvoice) => {
    return ![MerchantOrdersInvoiceState.CANCELLED, MerchantOrdersInvoiceState.PAID].includes(invoice.status)
}

export const MerchantInvoiceQRCodePrefix = "4"

export const merchantInvoiceTaskToQRcodeID = (invoice: IMerchantOrdersInvoice): string => {
    return `${MerchantInvoiceQRCodePrefix}${invoice.id}`
}